<template>
  <a-table :pagination='false' :loading='listLoading' bordered :rowKey='keyRow' :columns='columns' :data-source='data'>
    <template v-slot:exchange_name="{ record }">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.exchange_image)" alt="" style="width:50px;height:50px">
        </template>
        <template #description>
          <p class="s_omit2">{{record.exchange_name}}</p>
        </template>
      </a-card-meta>
    </template>
  </a-table>
</template>

<script>
  import { ref } from "vue";
  import store from "@/store";
  export default {
    name: "lookAssets",
    components: {},
    props: {
      listLoading:Boolean,
      columns:Array,
      data:Array,
      keyRow:String
    },
    setup() {
      return{
        info: ref(store.state.user.info),
      }
    },
  };
</script>
